import { render, staticRenderFns } from "./TimberPortfolio.vue?vue&type=template&id=49df6ef8&"
import script from "./TimberPortfolio.vue?vue&type=script&lang=js&"
export * from "./TimberPortfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports